import React from 'react';
import InstallBanner from './InstallBanner';

class Offline extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            online: navigator.onLine
        };
    }

    componentDidMount() {
        window.addEventListener('online', this.handleOnlineStatusChange);
        window.addEventListener('offline', this.handleOnlineStatusChange);
    }

    componentWillUnmount() {
        window.removeEventListener('online', this.handleOnlineStatusChange);
        window.removeEventListener('offline', this.handleOnlineStatusChange);
    }

    handleOnlineStatusChange = () => {
        this.setState({ online: navigator.onLine });
    }

    render() {
        const { children } = this.props;
        const { online } = this.state;

        return (
            <div>
                {!online && (
                    <div className="offline">
                        <div
                            className={`offline__content ${
                                !online ? "active" : ""
                            }`}
                        >
                            <svg>
                                <use href="#wifi-off" />
                            </svg>
                            <div className="offline__text">
                                <h2 className="underline-heading">
                                    You're not online
                                </h2>
                                <p>Check your internet connection.</p>
                            </div>
                        </div>
                    </div>
                )}
                <div
                    className={`offline__overlay ${
                        !online ? "offline__overlay--visible" : ""
                    }`}
                />
                {children}
                <InstallBanner />
            </div>
        );
    }
}

export default Offline;



// WEBPACK FOOTER //
// ./src/components/Offline.js